import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'ExternalAuthenticationLayout',
  props: {
    title: null,
    cardHeader: null
  },
  setup(__props: any) {



return { __sfc: true, }
}

})